var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["download-modal-tab-content", _vm.element.name] },
    [
      _c("p", [_vm._v(_vm._s(_vm.element.title))]),
      _vm._v(" "),
      _vm.element && _vm.element.items && _vm.element.items.length > 0
        ? _c(
            "select",
            {
              staticClass: "custom-select mb-3",
              on: { change: _vm.changeDropDown }
            },
            _vm._l(_vm.element.items, function(item, index) {
              return _c(
                "option",
                {
                  key: item.value,
                  domProps: {
                    value: item.value,
                    selected:
                      _vm.selectedValue &&
                      item.value === _vm.selectedValue.value
                  }
                },
                [
                  _vm.element.showItemIndex
                    ? _c("span", [_vm._v(" " + _vm._s(index + 1) + ": ")])
                    : _vm._e(),
                  _vm._v("\n      " + _vm._s(item.name) + "\n    ")
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.imageURL
        ? _c("img", {
            staticClass: "mb-3",
            attrs: { src: _vm.imageURL, alt: _vm.element.name }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "btn btn-white border border-dark w-100 justify-content-start",
          on: { click: _vm.downloadButtonClick }
        },
        [
          _c("span", {
            staticClass: "png-icon png-icon-icons-glyph--k-btn-download"
          }),
          _vm._v(" "),
          _c("span", { staticClass: "ml-2" }, [
            _vm._v("\n      " + _vm._s(_vm.element.downloadBtnText) + "\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.element.name === "swatch"
        ? _c(
            "a",
            {
              staticClass: "invisible",
              attrs: {
                id: "download-styles",
                download: "",
                href: _vm.downloadUrl
              },
              on: { click: _vm.downloadLinkClick }
            },
            [_vm._v("Download\n  ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }